import { IListObj } from "../../types/genericTypes";

export const marginSecNavOptions: Array<IListObj> = [
	{ value: "intraday", display: "Intraday", href: "/marginfiles/intraday/equity" },
	{ value: "collateral", display: "Collateral", href: "/marginfiles/collateral" },
	{ value: "coverorder", display: "Cover Order", href: "/marginfiles/coverorder" },
	{ value: "fno", display: "F&O Margin", href: "/marginfiles/fno" },
	{ value: "currency", display: "Currency Margin", href: "/marginfiles/currency" },
	{ value: "mcx", display: "MCX Margin", href: "/marginfiles/mcx/buy" },
	{ value: "ncdex", display: "NCDEX Margin", href: "/marginfiles/ncdex/buy" },
	{ value: "mtf", display: "MTF Stock List", href: "/marginfiles/mtf" }
];

export const marginQueryParams = {
	intraday: "intraday",
	fnointraday: "fno-intraday",
	collateral: "collateral",
	coverorder: "cover-order",
	fno: "fno",
	currency: "currency",
	mcx: "mcx",
	ncdex: "ncdex",
	mtf: "mtf"
};

export const marginIntraEqHeading = {
	edelCode: "Edel Code",
	nseSymbol: "NSE Symbol",
	isin: "ISIN",
	intradayMargin: "Intraday Margin %"
};

export const marginIntraFnoHeading = {
	scripName: "Scrip Name",
	marketlot: "Lot Size",
	totalMarginLongPos: "Total Margin % Long Pos",
	totalMarginPerLot: "Total Margin/Lot",
	misMargin: "MIS Margin %",
	misMarginperLot: "MIS Margin/Lot"
};

export const marginCollateralHeading = {
	edelCode: "Edel Code",
	companyname: "Company Name",
	haircut: "Haircut %"
};

export const marginCoverOrderHeading = {
	segment: "Segment",
	scrip: "Scrip Name",
	enterStopLoss: "Stop Loss %",
	minimumStopLossMargin: "Min Stop Loss Margin %",
	marginRequirement: "Margin Requirement %",
	finalMargin: "Final Margin %",
	times: "X Times"
};

export const marginFnoHeading = {
	trdSym: "Trading Symbol",
	mlot: "Lot Size",
	spanMarginPerLot: "Span Margin/ Lot",
	expMarginPerLot: "Exp Margin/ Lot",
	totalMarginPerLot: "Total Margin/ Lot",
	roundOff: "Round Off"
};

export const marginCurrencyHeading = {
	trdSym: "Trading Symbol",
	lotSize: "Lot Size",
	spanMarginAmt: "Span Margin Amount",
	expMarginamt: "Exp Margin Amount",
	totalMarginamt: "Total Margin Amount",
};

export const marginMcxHeading = {
	trdSym: "Trading Symbol",
	lotSize: "Lot Size",
	spanMargin: "Span Margin",
	expMargin: "Exp Margin(LTP)",
	spreadBenefit: "Spread Benefit",
	additionalMargin: "Add. Margin",
	totalMargin: "Total Margin"
};

export const marginMtfHeading = {
	name: "Company Name",
	nseSymbol: "NSE Symbol",
	bseCode: "BSE Code",
	isin: "ISIN",
	Haircut: "Current Haircut %"
};

export const marginEqFnoNavigationList: Array<IListObj> = [
	{ display: "Equity", value: "equity", href: "equity" },
	{ display: "FNO", value: "fno", href: "fno" }
];

export const marginBuySellNavigationList: Array<IListObj> = [
	{ display: "Buy", value: "buy", href: "buy" },
	{ display: "Sell", value: "sell", href: "sell" }
];

export enum EMarginScreenState {
	LOADING,
	DATA
}
